import { CloseOutlined } from "@ant-design/icons";
import { Form, FormInstance, FormProps, Input, Modal, Spin, TreeSelect } from "antd";
import { useEffect, useRef, useState } from "react";
import * as UnitApi from '../../../../api/unit/unitApi';
import useToast from "../../../../hook/useToast";
import { useForm } from "antd/lib/form/Form";
import LoadingSpin from "../../../../components/LoadingSpin";
import './styles.scss'


interface ModalProps {
  isOpen: boolean
  id: number | undefined
  dataListNationwide: []
  onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
  closeModal: () => void
}



const ModalEditUnit: React.FC<ModalProps> = ({
  isOpen,
  id,
  dataListNationwide,
  onSubmitFormModal,
  closeModal
}) => {
  const inputRef = useRef<FormInstance>(null);
  const [form] = useForm();
  const pushToast = useToast();

  const [checkloading, setCheckloading] = useState<boolean>(false)

  const [inputValue, setInputValue] = useState('');
  const [tags, setTags] = useState<string[]>([]);

  const updateFormValue = (newTags: string[]) => {
    setTags(newTags);

    // form.setFieldsValue({
    //   b7EntityCode: newTags,
    // });
  };

  const handleAddTag = () => {
    const value = inputValue.trim();

    if (!value) return;

    // không cho trùng
    if (tags.includes(value)) {
      setInputValue('');
      return;
    }

    const newTags = [...tags, value];

    updateFormValue(newTags);
    setInputValue('');
  };

  const handleRemoveTag = (tag: string) => {
    const newTags = tags.filter(item => item !== tag);

    updateFormValue(newTags);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };



  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };
  const onFinish: FormProps["onFinish"] = async (values) => {
    if (!tags.length) pushToast('Bạn cần nhập ít nhất 1 mã B7!', "error")


    if (id && values.codeUnit && values.nameUnit && values.ParentIdUnit) {
      setCheckloading(true)
      const result = await UnitApi.updateUnit(id, values.codeUnit, values.nameUnit, values.ParentIdUnit, tags);
      if (result?.status) {
        setCheckloading(false)
        onSubmitFormModal(true, result?.message)
      } else {
        onSubmitFormModal(false, result?.message)
        setCheckloading(false)
      }
    }
  };

  useEffect(() => {
    if (id) {
      handleDetail(id)
      setCheckloading(false)
    }

  }, [isOpen])

  const handleDetail = async (id: number) => {
    const result = await UnitApi.detailUnit(id);
    if (result?.status) {
      form.setFieldsValue({
        'codeUnit': result.data.code,
        'nameUnit': result.data.title,
        'ParentIdUnit': result.data.parentId,
        // 'b7EntityCode': result.data.b7EntityCode
      })
      setTags(result.data.b7EntityCode)
    } else {
      pushToast(result.message, "error", 2000)
    }
  }


  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa Đơn vị</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-sm text-344054 border-F2F4F7 bg-white h-8 px-15-px font-regular rounded-2 shadow-btn-save" onClick={closeModal}>Huỷ</button>
        <button
          className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={submitForm}
          disabled={checkloading}
        >
          Xác nhận
        </button>
      </div>}
    >
      <Form
        form={form}
        ref={inputRef}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <LoadingSpin
          checkLoading={checkloading}
        />
        <div className="d-flex flex-column gap-18-px p-6">
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Mã đơn vị
            </p>
            <Form.Item
              name="codeUnit"
              rules={[{ required: true, message: 'Nhập mã đơn vị!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Mã đơn vị"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm font-regular text-344054 d-flex gap-2 align-center mb-1">
              <span className="text-F5222D">*</span>
              Mã pháp nhân B7:
            </p>

            <Input
              value={inputValue}
              placeholder="Mã pháp nhân B7"
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              className="b7-input"
            />

            {Array.isArray(tags) && tags.length > 0 && (
             <div className="b7-tags custom-page-css scroll-custom pb-1">
                {tags.map(tag => (
                  <div key={tag} className="b7-tag custom-page-css max-w-full "
                  >
                    <span className="custom-page-css max-w-full text-truncate overflow-hidden">{tag}</span>
                    <CloseOutlined
                      className="b7-tag-close"
                      onClick={() => handleRemoveTag(tag)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Tên đơn vị
            </p>
            <Form.Item
              name="nameUnit"
              rules={[{ required: true, message: 'Nhập tên đơn vị!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Tên đơn vị"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Chọn văn phòng điều hành
            </p>
            <Form.Item
              name="ParentIdUnit"
              rules={[{ required: true, message: 'Chọn văn phòng điều hành!' }]}
              className="m-none-form-item text-explan"
            >
              <TreeSelect
                showSearch
                placeholder="Chọn văn phòng điều hành"
                allowClear
                treeDefaultExpandAll={false}
                treeData={dataListNationwide}
                className="custom-tree-select "
                filterTreeNode={(input: string, option: any) =>
                  typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }


              />
            </Form.Item>
          </div>

        </div>
      </Form>
    </Modal>
  )
}
export default ModalEditUnit
